import React from "react";
import { FaShieldAlt, FaGavel, FaInfoCircle, FaExclamationTriangle, FaCheckCircle, FaClock } from "react-icons/fa";

const ProgressTimeline = ({ progress }) => {
  return (
    <div className="space-y-4 mt-6">
      <h3 className="text-lg font-semibold text-white">Activity Log</h3>
      
      {progress.length === 0 ? (
        <div className="text-gray-400 text-sm italic">No recent activity</div>
      ) : (
        <ul className="space-y-3">
          {progress.map((entry, index) => {
            // Determine icon based on type and status
            let Icon = FaInfoCircle;
            let iconColor = "text-blue-400";
            
            if (entry.type === "error") {
              Icon = FaExclamationTriangle;
              iconColor = "text-red-400";
            } else if (entry.type === "success") {
              Icon = FaCheckCircle;
              iconColor = "text-green-400";
            }
            
            const isLoading = entry.status === "starting";
            
            return (
              <li key={index} className="flex items-start space-x-3 p-3 rounded-lg bg-gray-700 bg-opacity-50">
                <div className={`mt-0.5 flex-shrink-0 ${iconColor}`}>
                  {isLoading ? (
                    <FaClock className="animate-pulse" />
                  ) : (
                    <Icon />
                  )}
                </div>
                <div>
                  <p className={`text-sm font-medium ${
                    entry.type === "error" ? "text-red-300" : 
                    entry.type === "success" ? "text-green-300" : 
                    "text-white"
                  }`}>
                    {entry.message}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {isLoading ? "In progress..." : entry.status === "finished" ? "Completed" : ""}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

const RightColumn = ({ transactionCommission, disputeCommission, progress, Coin }) => {
  return (
    <div className="space-y-6">
      {/* Commission Details */}
      <div>
        <h3 className="text-lg font-semibold text-white mb-4">Fee Information</h3>
        
        <div className="space-y-4">
          <div className="p-4 bg-gray-700 bg-opacity-50 rounded-lg border border-gray-600 flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-green-500 bg-opacity-20 p-2 rounded-lg mr-3">
                <FaShieldAlt className="text-green-400" />
              </div>
              <span className="text-gray-300">Transaction Fee</span>
            </div>
            <div className="text-white font-medium">
              {transactionCommission} {Coin}
            </div>
          </div>
          
          <div className="p-4 bg-gray-700 bg-opacity-50 rounded-lg border border-gray-600 flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-yellow-500 bg-opacity-20 p-2 rounded-lg mr-3">
                <FaGavel className="text-yellow-400" />
              </div>
              <span className="text-gray-300">Dispute Fee</span>
            </div>
            <div className="text-white font-medium">
              {disputeCommission} {Coin}
            </div>
          </div>
        </div>
        
        <div className="mt-4 p-3 bg-blue-900 bg-opacity-20 border border-blue-800 rounded-lg">
          <p className="text-xs text-blue-300">
            Fees are paid in {Coin} and cover transaction processing and network costs. Dispute fees are only charged when initiating a dispute.
          </p>
        </div>
      </div>
      
      {/* Progress Timeline */}
      <ProgressTimeline progress={progress} />
      
      {/* Security Information */}
      <div className="p-4 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg border border-gray-700">
        <h3 className="text-lg font-semibold text-white mb-3">Security Verified</h3>
        <div className="space-y-2">
          <div className="flex items-center">
            <FaCheckCircle className="text-green-400 mr-2" />
            <span className="text-gray-300 text-sm">Smart Contract Audited</span>
          </div>
          <div className="flex items-center">
            <FaCheckCircle className="text-green-400 mr-2" />
            <span className="text-gray-300 text-sm">Blockchain Verified</span>
          </div>
          <div className="flex items-center">
            <FaCheckCircle className="text-green-400 mr-2" />
            <span className="text-gray-300 text-sm">Secure Connection</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightColumn;